/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_ButtonInputs */

const en_directory_submit_badge_button = /** @type {(inputs: Directory_Submit_Badge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify badge`)
};

const zh_directory_submit_badge_button = /** @type {(inputs: Directory_Submit_Badge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证徽章`)
};

/**
* | output |
* | --- |
* | "Verify badge" |
*
* @param {Directory_Submit_Badge_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_button = /** @type {((inputs?: Directory_Submit_Badge_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_button(inputs)
	return zh_directory_submit_badge_button(inputs)
});
export { directory_submit_badge_button as "directory.submit.badge_button" }